"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(min, max, t) {
  var mu2 = (1 - Math.cos(t * Math.PI)) / 2;
  return min * (1 - mu2) + max * mu2;
}; // TODO : Check out -> https://github.com/osuushi/Smooth.js/


exports["default"] = _default;